var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableCloseEventListener, CloseEventListener, OpenEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { HeadingSectionProperties } from './heading-section-types.js';
class HeadingSectionAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /**@event */
        this.onOpen = new OpenEventListener();
        /**@event */
        this.onBeforeClose = new AbortableCloseEventListener();
        /**@event */
        this.onClose = new CloseEventListener();
    }
    /**
     * Gets the header background color.
     *
     * @returns The header background color.
     */
    getHeaderBackgroundColor() {
        return this.state.headerBackgroundColor ?? HeadingSectionProperties.headerBackgroundColor.defaultValue;
    }
    /**
     * Sets the header background color.
     *
     * @param headerBackgroundColor - The header background color.
     */
    setHeaderBackgroundColor(headerBackgroundColor) {
        this.setState({ ...this.state, headerBackgroundColor });
    }
    /**
     * Opens the section.
     */
    open() {
        if (this.isOpen()) {
            return;
        }
        this.setState({ ...this.state, collapsed: false });
        this.onOpen.fire();
    }
    /**
     * Closes the section.
     */
    close() {
        if (!this.isOpen()) {
            return;
        }
        let close = true;
        const abort = () => { close = false; };
        this.onBeforeClose.fire({ abort });
        if (close) {
            this.onClose.fire();
            this.setState({ ...this.state, collapsed: true });
        }
    }
    /**
     * Gets the open state of the section.
     *
     * @returns If the section is open or closed.
     */
    isOpen() {
        return !this.state.collapsed;
    }
    /**
     * Gets if the section collapse button will be shown.
     *
     * @returns If the section collapse button will be shown.
     */
    getShowCollapseButton() {
        return Boolean(this.state.showCollapseButton);
    }
    /**
     * Sets if the section collapse button will be shown.
     *
     * @param showCollapseButton - If the section collapse button will be shown.
     */
    setShowCollapseButton(showCollapseButton) {
        this.setState({ ...this.state, showCollapseButton });
    }
    /**
     * Gets the section title.
     *
     * @returns The section title.
     */
    getTitle() {
        return this.state.title;
    }
    /**
     * Sets the section title.
     *
     * @param title - The section title.
     */
    setTitle(title) {
        this.setState({ ...this.state, title });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], HeadingSectionAPI.prototype, "onOpen", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], HeadingSectionAPI.prototype, "onBeforeClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], HeadingSectionAPI.prototype, "onClose", void 0);
export { HeadingSectionAPI, };
//# sourceMappingURL=heading-section-api.js.map